export default __webpack_public_path__ + "static/media/notification.a848ef21.mp3";